/* eslint-disable react/forbid-prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React from 'react';
import PropTypes from 'prop-types';
import { MdOutlineCheck } from 'react-icons/md';

function AppChip({
  showIcon,
  chipText,
  name,
  selected,
  value,
  className,
  onClick,
}) {
  return (
    <div
      onClick={() => onClick(name, value)}
      className={`app-chip ${className} ${selected ? 'app-chip-selected' : ''}`}
    >
      {showIcon && (
        <MdOutlineCheck style={{ fontSize: '12px', marginRight: '6px' }} />
      )}
      <span style={{ fontWeight: 500, fontSize: '12px' }}>{chipText}</span>
    </div>
  );
}

AppChip.defaultProps = {
  selected: false,
  className: '',
  showIcon: false,
  onClick: () => {},
};

AppChip.propTypes = {
  selected: PropTypes.bool,
  className: PropTypes.string,
  showIcon: PropTypes.bool,
  onClick: PropTypes.func,
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  chipText: PropTypes.any.isRequired,
};

export default AppChip;
